import { css } from "@emotion/css";
import { Text } from "components/common";
import { SignOutIcon } from "components/icons";
import { LogoutDialog } from "components/layout/LogoutDialog";
import React, { useState } from "react";

export const LogoutButton: React.FC = () => {
  const [showLogout, setShowLogout] = useState(false);

  const handleLogout = () => {
    setShowLogout(true);
  };

  return (
    <div>
      <div
        className={css`
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          cursor: pointer;
          width: 100%;
        `}
        onClick={handleLogout}
      >
        <SignOutIcon
          fill="#fff"
          style={{
            height: "16px",
            width: "16px",
            marginRight: "8px",
          }}
        />

        <Text.BodySM marginBottom={0} marginTop={0}>
          Log Out
        </Text.BodySM>
      </div>

      <LogoutDialog open={showLogout} onOpenChange={setShowLogout} />
    </div>
  );
};
